import React from "react"
import { Page, Table, Typography, Button } from "../../../../../design-system"

import LoadingContainer from "../../../../../_components/LoadingContainer"
import { getNFeTransporters } from "../../../../../api/nfe"
import { formatDocument } from "../../../../../utils"

import Transporter from "../Transporter"

export default props => {

    const ref = React.useRef(null)
    const [show, setShow] = React.useState(false)
    const [data, setData] = React.useState([])
    const [selectedItem, setSelectedItem] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    function onHide() {
        setShow(false)
    }
    function onEditTransport(item) {
        setShow(true)
        setSelectedItem(item)
    }

    function loadData() {
        setLoading(true)
        getNFeTransporters()
            .then(_ => {
                setData(_)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }
    React.useEffect(loadData, [ref.current])

    return (
        <Page
            title="Transportadoras"
            subtitle="Gerencie as transportadoras cadastradas para emissão de notas."
        >
            <div ref={ref}>
                <div className="row mb-4">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <Typography variant="cardTitle">
                            Lista de Transportadoras
                        </Typography>
                        <Transporter show={show} data={selectedItem} onHide={onHide} />
                    </div>
                </div>

                <LoadingContainer loading={loading}>
                    <div className="row">
                        <div className="col-12">
                            <Table striped hover responsive paginate>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>#</Table.HeaderCell>
                                        <Table.HeaderCell>Nome</Table.HeaderCell>
                                        <Table.HeaderCell>CPF/CNPJ</Table.HeaderCell>
                                        <Table.HeaderCell>IE</Table.HeaderCell>
                                        <Table.HeaderCell>Cidade</Table.HeaderCell>
                                        <Table.HeaderCell style={{ width: '100px', textAlign: 'center' }}>Ações</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {data.length === 0 && !loading ? (
                                        <Table.Row>
                                            <Table.Cell colSpan={6} style={{ textAlign: 'center', padding: '2rem' }}>
                                                <Typography variant="paragraph" style={{ fontStyle: 'italic' }}>
                                                    Nenhuma transportadora encontrada.
                                                </Typography>
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        data.map((item, idx) => {
                                            const cpfCnpj = formatDocument(item.cpf || item.cnpj)
                                            return (
                                                <Table.Row key={`transport-list-item-${item.id}`}>
                                                    <Table.Cell>{idx + 1}</Table.Cell>
                                                    <Table.Cell>{item.name}</Table.Cell>
                                                    <Table.Cell>{cpfCnpj}</Table.Cell>
                                                    <Table.Cell>{item.state_registry}</Table.Cell>
                                                    <Table.Cell>{(item.city_location && item.city_location.city_name) || "-"}</Table.Cell>
                                                    <Table.Cell style={{ textAlign: 'center' }}>
                                                        <Button 
                                                            variant="tertiary" 
                                                            size="xs" 
                                                            onClick={() => onEditTransport(item)}
                                                            title="Editar Transportadora"
                                                        >
                                                            <i className="fa fa-edit" />
                                                        </Button>
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        })
                                    )}
                                </Table.Body>
                            </Table>
                        </div>
                    </div>
                </LoadingContainer>
            </div>
        </Page>
    )
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Transport/List/index.jsx